import Client from './client';

export default class Screens extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  putByKey(key, options = {}) {
    return this.makeRequest(`${this.host}/screens/${key}`, {
      ...options,
       method: 'PUT',
    });
  }

}
